import {
  INITIALS_LABEL,
  JOB_FAMILY_LABEL,
} from "../../../../../../../constants/Dictionary";
import {
  ManagementTable,
  ManagementTableHeader,
} from "../../../../../Components/Table/ManagementTable";
import { JobFamilyConfigItem } from "../../../../../../../types/api/configurations.type";
import { compareDataGeneric } from "../../../../../../../utils/comparing.utils";
import { FieldValues } from "react-hook-form";
import {
  useManageJobFamilies,
  useUpdateManageJobFamilies,
} from "../../../../../../../hooks/management/CmSheet/InternalGrade/useManagementJobFamilies.hooks";

type ManageJobFamiliesProps = {
  setDisableFilters: (x: boolean) => void;
  configYear: number;
};

export const ManageJobFamilies = ({
  setDisableFilters,
  configYear,
}: ManageJobFamiliesProps) => {
  const { data, isFetching } = useManageJobFamilies(configYear);
  const { mutate: updateJobFamilies, isPending: isUpdatingJobfamilies } =
    useUpdateManageJobFamilies();

  const jobFamiliesColumns: ManagementTableHeader[] = [
    {
      key: "name",
      label: JOB_FAMILY_LABEL,
      width: 60,
      type: "text",
    },
    {
      key: "initials",
      label: INITIALS_LABEL,
      width: 40,
      type: "text",
    },
  ];

  const onSave = async (formData: FieldValues) => {
    const compareData = (formData.items as JobFamilyConfigItem[]).map(
      (item, index) => ({
        ...item,
        position: index + 1,
      }),
    );
    const result = compareDataGeneric<JobFamilyConfigItem>(data!, compareData);
    updateJobFamilies(result);
  };

  return (
    <ManagementTable<JobFamilyConfigItem>
      data={data ?? []}
      headers={jobFamiliesColumns}
      itemLabel={JOB_FAMILY_LABEL}
      draggableRows={true}
      keyItem={"name"}
      toggleFilters={setDisableFilters}
      onSave={onSave}
      loading={isFetching || isUpdatingJobfamilies}
    />
  );
};
